<template><ArticlePage page="blog-ios" :content="content" show-mobile-download /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/blog-ios.js';
export default { name: 'BlogIos', components: { ArticlePage }, data: () => ({ content }) };
</script>
